/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611040307-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqCapturesApiClass {
 
   constructor() {}

  /**
   * @summary Archive a capture. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public archiveCapture(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Create a capture of a workstep. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createCapture(
    body: models.CaptureInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures`;
    const urlTemplate = `${baseUrl}/captures`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CaptureOutputV1>;
  }

  /**
   * @summary Get a capture and its marks. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getCapture(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.CaptureOutputV1>;
  }

  /**
   * @summary List the captures the caller can read, newest first. This endpoint is experimental and may change in future releases.
   * @param {boolean} [mine=false] - Only the captures the caller created
   * @param {string} [workbookId] - Only the captures taken from this workbook
   * @param {string} [search] - Case-insensitive text to match in the title, description or workbook name. Also matches a capture by its number.
   * @param {number} [offset=0] - Pagination offset
   * @param {number} [limit=40] - Page size
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getCaptures(
    {
      mine,
      workbookId,
      search,
      offset,
      limit
    } : {
      mine?: boolean,
      workbookId?: string,
      search?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures`;
    const urlTemplate = `${baseUrl}/captures`;

    const queryParams = {
      ['mine']: mine,      ['workbookId']: workbookId,      ['search']: search,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.CaptureOutputListV1>;
  }

  /**
   * @summary Get a capture's picture. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getPicture(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}/image`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}/image`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Replace a capture's picture, its marks and its layout. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @param {Blob} [file]
   * @param {string} [marks]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public replacePicture(
    {
      id,
      file,
      marks
    } : {
      id: string,
      file?: File,
      marks?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}/picture`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}/picture`;


    const formData = new FormData();
    formData.append('file', file as File, file?.name);
    if (marks !== undefined) {
      formData.append('marks', marks);
    }

    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.CaptureOutputV1>;

  }

  /**
   * @summary Share a capture by email with Seeq users and groups. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public shareCapture(
    body: models.CaptureShareInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}/shares`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}/shares`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CaptureShareOutputV1>;
  }

  /**
   * @summary Ask AI to propose a title and description for a capture. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @param {string} [description]
   * @param {Blob} [file]
   * @param {string} [language]
   * @param {string} [title]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public suggestCaptureText(
    {
      id,
      description,
      file,
      language,
      title
    } : {
      id: string,
      description?: string,
      file?: File,
      language?: string,
      title?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}/suggestions`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}/suggestions`;


    const formData = new FormData();
    if (description !== undefined) {
      formData.append('description', description);
    }
    formData.append('file', file as File, file?.name);
    if (language !== undefined) {
      formData.append('language', language);
    }
    if (title !== undefined) {
      formData.append('title', title);
    }

    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.CaptureSuggestionOutputV1>;

  }

  /**
   * @summary Unarchive a capture. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public unarchiveCapture(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}/unarchive`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}/unarchive`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Update a capture's title and description. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID of the capture
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateCapture(
    body: models.CaptureUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/captures/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/captures/{id}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CaptureOutputV1>;
  }

}


export const sqCapturesApi = new sqCapturesApiClass();

export type sqCapturesApiEndpoints = {
  'archiveCapture': {
    method: 'delete';
    path: '/captures/${encodeURIComponent(String(id))}';
    response: {};
  };
  'createCapture': {
    method: 'post';
    path: '/captures';
    response: models.CaptureOutputV1;
  };
  'getCapture': {
    method: 'get';
    path: '/captures/${encodeURIComponent(String(id))}';
    response: models.CaptureOutputV1;
  };
  'getCaptures': {
    method: 'get';
    path: '/captures';
    response: models.CaptureOutputListV1;
  };
  'getPicture': {
    method: 'get';
    path: '/captures/${encodeURIComponent(String(id))}/image';
    response: string;
  };
  'replacePicture': {
    method: 'put';
    path: '/captures/${encodeURIComponent(String(id))}/picture';
    response: models.CaptureOutputV1;
  };
  'shareCapture': {
    method: 'post';
    path: '/captures/${encodeURIComponent(String(id))}/shares';
    response: models.CaptureShareOutputV1;
  };
  'suggestCaptureText': {
    method: 'post';
    path: '/captures/${encodeURIComponent(String(id))}/suggestions';
    response: models.CaptureSuggestionOutputV1;
  };
  'unarchiveCapture': {
    method: 'post';
    path: '/captures/${encodeURIComponent(String(id))}/unarchive';
    response: {};
  };
  'updateCapture': {
    method: 'put';
    path: '/captures/${encodeURIComponent(String(id))}';
    response: models.CaptureOutputV1;
  };
};

type ApiArchiveCaptureResponse = {};
type ApiarchiveCaptureMutationParams = Parameters<typeof sqCapturesApi.archiveCapture> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.archiveCapture>;

export function useApiArchiveCaptureMutation(
  options?: Omit<UseMutationOptions<ApiArchiveCaptureResponse, AxiosError<SeeqErrorData>,
    ApiarchiveCaptureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveCaptureResponse, AxiosError<SeeqErrorData>,
  ApiarchiveCaptureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveCaptureMutationParams) =>
      sqCapturesApi.archiveCapture(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateCaptureResponse = models.CaptureOutputV1;
type ApicreateCaptureMutationParams = Parameters<typeof sqCapturesApi.createCapture> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.createCapture>;
type ApicreateCaptureMutationVariables = models.CaptureInputV1;

export function useApiCreateCaptureMutation(
  options?: Omit<UseMutationOptions<ApiCreateCaptureResponse, AxiosError<SeeqErrorData>,
    ApicreateCaptureMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateCaptureResponse, AxiosError<SeeqErrorData>,
  ApicreateCaptureMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateCaptureMutationVariables) =>
      sqCapturesApi.createCapture(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetCaptureResponse = models.CaptureOutputV1;
export function GetCaptureQueryKey(
  params: Parameters<typeof sqCapturesApi.getCapture>[0],
) {
  return ['sqCapturesApi', 'getCapture', params] as const;
}

export function useApiGetCaptureQuery(
  params: Parameters<typeof sqCapturesApi.getCapture>[0],
  options?: Omit<UseQueryOptions<ApiGetCaptureResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetCaptureResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetCaptureQueryKey(params),
    queryFn: () =>
      sqCapturesApi.getCapture(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCapturesResponse = models.CaptureOutputListV1;
export function GetCapturesQueryKey(
  params: Parameters<typeof sqCapturesApi.getCaptures>[0],
) {
  return ['sqCapturesApi', 'getCaptures', params] as const;
}

export function useApiGetCapturesQuery(
  params: Parameters<typeof sqCapturesApi.getCaptures>[0],
  options?: Omit<UseQueryOptions<ApiGetCapturesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetCapturesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetCapturesQueryKey(params),
    queryFn: () =>
      sqCapturesApi.getCaptures(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetPictureResponse = string;
export function GetPictureQueryKey(
  params: Parameters<typeof sqCapturesApi.getPicture>[0],
) {
  return ['sqCapturesApi', 'getPicture', params] as const;
}

export function useApiGetPictureQuery(
  params: Parameters<typeof sqCapturesApi.getPicture>[0],
  options?: Omit<UseQueryOptions<ApiGetPictureResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetPictureResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetPictureQueryKey(params),
    queryFn: () =>
      sqCapturesApi.getPicture(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiReplacePictureResponse = models.CaptureOutputV1;
type ApireplacePictureMutationParams = Parameters<typeof sqCapturesApi.replacePicture> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.replacePicture>;

export function useApiReplacePictureMutation(
  options?: Omit<UseMutationOptions<ApiReplacePictureResponse, AxiosError<SeeqErrorData>,
    ApireplacePictureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiReplacePictureResponse, AxiosError<SeeqErrorData>,
  ApireplacePictureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApireplacePictureMutationParams) =>
      sqCapturesApi.replacePicture(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiShareCaptureResponse = models.CaptureShareOutputV1;
type ApishareCaptureMutationParams = Parameters<typeof sqCapturesApi.shareCapture> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.shareCapture>;

export function useApiShareCaptureMutation(
  options?: Omit<UseMutationOptions<ApiShareCaptureResponse, AxiosError<SeeqErrorData>,
    ApishareCaptureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiShareCaptureResponse, AxiosError<SeeqErrorData>,
  ApishareCaptureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApishareCaptureMutationParams) =>
      sqCapturesApi.shareCapture(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSuggestCaptureTextResponse = models.CaptureSuggestionOutputV1;
type ApisuggestCaptureTextMutationParams = Parameters<typeof sqCapturesApi.suggestCaptureText> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.suggestCaptureText>;

export function useApiSuggestCaptureTextMutation(
  options?: Omit<UseMutationOptions<ApiSuggestCaptureTextResponse, AxiosError<SeeqErrorData>,
    ApisuggestCaptureTextMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSuggestCaptureTextResponse, AxiosError<SeeqErrorData>,
  ApisuggestCaptureTextMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApisuggestCaptureTextMutationParams) =>
      sqCapturesApi.suggestCaptureText(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUnarchiveCaptureResponse = {};
type ApiunarchiveCaptureMutationParams = Parameters<typeof sqCapturesApi.unarchiveCapture> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.unarchiveCapture>;

export function useApiUnarchiveCaptureMutation(
  options?: Omit<UseMutationOptions<ApiUnarchiveCaptureResponse, AxiosError<SeeqErrorData>,
    ApiunarchiveCaptureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUnarchiveCaptureResponse, AxiosError<SeeqErrorData>,
  ApiunarchiveCaptureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiunarchiveCaptureMutationParams) =>
      sqCapturesApi.unarchiveCapture(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateCaptureResponse = models.CaptureOutputV1;
type ApiupdateCaptureMutationParams = Parameters<typeof sqCapturesApi.updateCapture> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCapturesApi.updateCapture>;

export function useApiUpdateCaptureMutation(
  options?: Omit<UseMutationOptions<ApiUpdateCaptureResponse, AxiosError<SeeqErrorData>,
    ApiupdateCaptureMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateCaptureResponse, AxiosError<SeeqErrorData>,
  ApiupdateCaptureMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateCaptureMutationParams) =>
      sqCapturesApi.updateCapture(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
